import { defineStore } from 'pinia'
import { authService } from '@/services/auth.service'

export const useAuthStore = defineStore('auth', {
  state: () => ({
    user: JSON.parse(localStorage.getItem('user')),
    returnUrl: null,
    isLoading: false
  }),
  
  getters: {
    isAuthenticated: (state) => !!state.user,
    token: (state) => state.user?.token
  },
  
  actions: {
    async login(email, password) {
      try {
        const user = await authService.login(email, password)
        this.user = user
        return user
      } catch (error) {
        throw error
      }
    },

    async checkSession() {
      if (!this.isAuthenticated) return null
      
      try {
        const userData = await authService.me()
        return userData
      } catch (error) {
        this.logout()
        throw error
      }
    },

    async forgotPassword(email) {
      return await authService.forgotPassword(email)
    },

    async resetPassword(token, password) {
      return await authService.resetPassword(token, password)
    },

    logout() {
      this.user = null
      authService.logout()
    },

    async register(userData) {
      try {
        return await authService.register(userData)
      } catch (error) {
        throw error
      }
    }
  }
}) 